/**
 * 公共方法
 * */
/**
 * 公共方法
 * */

// 导入公共模块
export * from '@src/_common/utils/mUtils';
import moduleConfig from '@src/bigdata-capital-h5/common/js/moduleConfig';
/* 调用原生方法  fn:定义的方法 arg:定义的参数 */
export const commonCall = (fn, type, byte, errFn) => {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    try {
      window.JsBridge[fn](type, byte);
    } catch (err) {
      console.log(err);
      errFn();
    }
  } else if (isiOS) {
    try {
      console.log('IOS方法调用', fn, type, byte);
      let params = type + ',' + byte;
      window.webkit.messageHandlers[fn].postMessage(params, params);
    } catch (err) {
      console.log(err);
      errFn();
    }
  }
};

/**
 * 获取配置文件
 * moduleCode：模板标识
 * code: 接口interfaceCode
 * type: 配置参数类型
 */
export const getConfig = (moduleCode, code, type) => {
  let config = moduleConfig[moduleCode];
  let currentConfig = {};
  config.forEach((c) => {
    if (c.interfaceCode === code) {
      currentConfig = c.config;
    }
  });
  // 如果有type，着返回对应的数据
  if (type) {
    return currentConfig[type];
  } else {
    return currentConfig;
  }
};

// 导入公共模块
export * from '@src/_common/utils/mUtils';
